// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"94b6fd7c","183":"390c8532","233":"0f669d5b","453":"04c79a43","469":"a5d2cae1","906":"0329a072","997":"3131e9d4"}[chunkId] + ".chunk.js";
};